/* eslint-disable camelcase */
import { InventoryLocationBuilding, InventoryLocationBuildingFloorplan } from '@enmon/commons/lib/tools';

type NoNullField<T> = {
  [P in keyof T]: Exclude<T[P], null>;
};

export type ValidatedFloorplan = NoNullField<InventoryLocationBuildingFloorplan> & {
  inv_loc_building: InventoryLocationBuilding;
};

export function isFloorplanValid(
  floorplan?: Partial<InventoryLocationBuildingFloorplan>,
): floorplan is ValidatedFloorplan {
  return !!floorplan && floorplan.height !== null && floorplan.file_drive_id !== null && floorplan.width !== null;
}
